import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    ViewChild,
    Output,
    EventEmitter,
} from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainSearch,
    RecurrenceFilterModel,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    FilterTypes,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import {
    NgbModalRef,
    NgbModal,
    NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import {
    LocationLookup,
    GenericMaster,
    CallDescriptionLookup,
    CallCategoryLookup,
    VIP,
    GenericMaster_String,
    GlitchDescription,
    GlitchCategory,
} from "../../Models/GlobalEntities";
import * as alasql from "alasql";
import { JobFilterInner } from "../JobFilterInner/JobFilterInner";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { untilDestroyed } from "ngx-take-until-destroy";

@Component({
    selector: "JobFilter",
    templateUrl: "./JobFilter.html",
})
export class JobFilter extends BaseComponent implements OnInit, OnDestroy {
    RequestModel: any = {};

    ModalRef: NgbModalRef;

    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstPriority: Array<GenericMaster> = [];
    lstCallDescriptions: Array<CallDescriptionLookup> = [];
    lstCallCategories: Array<CallCategoryLookup> = [];
    lstDepartments: Array<GenericMaster> = [];
    lstSections: Array<GenericMaster> = [];
    lstVIP: Array<VIP> = [];
    lstGlitchCategories: Array<GlitchCategory> = [];
    lstGlitchDescriptions: Array<GlitchDescription> = [];
    lstGlitchStaffs: Array<GenericMaster> = [];
    lstLoggedByStaffs: Array<GenericMaster> = [];
    lstTaggedStaffs: Array<GenericMaster> = [];
    lstInvolvedStaffs: Array<GenericMaster> = [];
    lstloggedDate: Array<GenericMaster> = [];
    lastPax: Array<any> = [
        {
            Name: "1",
            Id: 1,
        },
        {
            Name: "2",
            Id: 2,
        },
        {
            Name: "3",
            Id: 3,
        },
        {
            Name: "4",
            Id: 4,
        },
        {
            Name: "5",
            Id: 5,
        },
        {
            Name: "6",
            Id: 6,
        },
        {
            Name: "7",
            Id: 7,
        },
        {
            Name: "8",
            Id: 8,
        },
        {
            Name: "9",
            Id: 9,
        },
        {
            Name: "10",
            Id: 10,
        },
    ];
    lstLastProps: Array<number> = [];

    @Output() ApplyFilter = new EventEmitter();

    _FilterTypes = FilterTypes;

    @Input() EnabledFilters: Array<FilterTypes> = [
        FilterTypes.AssignedTo,
        FilterTypes.CallCategory,
        FilterTypes.CallDescription,
        FilterTypes.Dept,
        FilterTypes.Location,
        FilterTypes.IsGuestCall,
        FilterTypes.LoggedBy,
        FilterTypes.ReportedBy,
        FilterTypes.Sections,
        FilterTypes.Vip,
        FilterTypes.IsKMTCategory,
        FilterTypes.HasAttachment,
        FilterTypes.HasEscalation,
        FilterTypes.TaggedStaffIds,
        FilterTypes.LoggedDate,
        FilterTypes.Priority    
    ];

    innerFilter: JobFilterInner;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        private complainService: ComplainService,
        private modalService: NgbModal
    ) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {}

    CheckPropertyChange(): boolean {
        if (this.lstLastProps.length != this.RequestModel.Properties.length)
            return true;

        for (let i = 0; i < this.lstLastProps.length; i++) {
            let lastID = this.lstLastProps[i];
            let idx = this.RequestModel.Properties.findIndex(
                (a) => a == lastID
            );

            if (idx == -1) return true;
        }

        return false;
    }

    CFE(checkfor: FilterTypes) {
        if (this.EnabledFilters.findIndex((a) => a == checkfor) >= 0)
            return true;
        else return false;
    }

    onOpen(Model: any): void {
        this.RequestModel = Model;

        if (this.CheckPropertyChange() == true) {
            this.lstLocations = [];
            this.lstCallDescriptions = [];
            this.lstCallCategories = [];
            this.lstStaff = [];

            this.lstDepartments = [];
            this.lstSections = [];
            this.lstVIP = [];
            for (let i = 0; i < this.RequestModel.Properties.length; i++) {
                let propID = this.RequestModel.Properties[i];

                let objProp =
                    this.masterService.Cache_PropertyMainMasters.getValue(
                        propID
                    );

                if (objProp != null) {
                    let res: Array<any>;

                    this.CFE(FilterTypes.Location)
                        ? (this.lstLocations = this.lstLocations.concat(
                              objProp.Location
                          ))
                        : null;

                    this.CFE(FilterTypes.CallDescription)
                        ? (this.lstCallDescriptions =
                              this.lstCallDescriptions.concat(
                                  _.cloneDeep(
                                      this.masterService.GetCallDescritpion(
                                          propID
                                      )
                                  )
                                      .filter((a) => !a.IsDel)
                                      .filter(
                                          (a) =>
                                              !this.lstCallDescriptions.find(
                                                  (b) => a.Id == b.Id
                                              )
                                      )

                                  //   alasql(
                                  //       "Select * from ? where Id not in (Select Id from ?)",
                                  //       [
                                  //           objProp.CallDescriptions,
                                  //           this.lstCallDescriptions,
                                  //       ]
                                  //   )
                              ))
                        : null;
                    this.CFE(FilterTypes.CallCategory)
                        ? (this.lstCallCategories =
                              this.lstCallCategories.concat(
                                  alasql(
                                      "Select * from ? where Id not in (Select Id from ?)",
                                      [
                                          objProp.CallCategories,
                                          this.lstCallCategories,
                                      ]
                                  )
                              ))
                        : null;
                    this.CFE(FilterTypes.LoggedBy) ||
                    this.CFE(FilterTypes.ReportedBy) ||
                    this.CFE(FilterTypes.AssignedTo)
                        ? (this.lstStaff = this.lstStaff.concat(
                              alasql(
                                  "Select * from ? where Id not in (Select Id from ?)",
                                  [objProp.Staff, this.lstStaff]
                              )
                          ))
                        : null;
                    this.CFE(FilterTypes.Dept)
                        ? (this.lstDepartments = this.lstDepartments.concat(
                              alasql(
                                  "Select * from ? where Id not in (Select Id from ?)",
                                  [objProp.Dept, this.lstDepartments]
                              )
                          ))
                        : null;
                    this.CFE(FilterTypes.Sections)
                        ? (this.lstSections = this.lstSections.concat(
                              alasql(
                                  "Select * from ? where Id not in (Select Id from ?)",
                                  [objProp.Sections, this.lstSections]
                              )
                          ))
                        : null;
                    this.CFE(FilterTypes.Vip)
                        ? (this.lstVIP = this.lstVIP.concat(
                              alasql(
                                  "Select * from ? where Code not in (Select Code from ?)",
                                  [objProp.VIPs, this.lstVIP]
                              )
                          ))
                        : null;
                    this.CFE(FilterTypes.GlitchCategory)
                        ? (this.lstGlitchCategories =
                              this.lstGlitchCategories.concat(
                                  alasql(
                                      "Select * from ? where Id  not in (Select Id from ?)",
                                      [
                                          objProp.GlitchCategories,
                                          this.lstGlitchCategories,
                                      ]
                                  )
                              ))
                        : null;
                    this.CFE(FilterTypes.GlitchDescription)
                        ? (this.lstGlitchDescriptions =
                              this.lstGlitchDescriptions.concat(
                                  _.cloneDeep(
                                      this.masterService.GetGlitchDescritpion(
                                          propID
                                      )
                                  )
                                      .filter((a) => !a.IsDel)
                                      .filter(
                                          (a) =>
                                              !this.lstGlitchDescriptions.find(
                                                  (b) => a.Id == b.Id
                                              )
                                      )

                                  //   alasql(
                                  //       "Select * from ? where Id not in (Select Id from ?)",
                                  //       [
                                  //           objProp.GlitchDescriptionMaster,
                                  //           this.lstGlitchDescriptions,
                                  //       ]
                                  //   )
                              ))
                        : null;
                    this.CFE(FilterTypes.GlitchStaff)
                        ? (this.lstGlitchStaffs = this.lstGlitchStaffs.concat(
                              alasql(
                                  "Select * from ? where Id not in (Select Id from ?)",
                                  [objProp.Staff, this.lstGlitchStaffs]
                              )
                          ))
                        : null;
                    this.CFE(FilterTypes.RegisteredBy)
                        ? (this.lstLoggedByStaffs =
                              this.lstLoggedByStaffs.concat(
                                  alasql(
                                      "Select * from ? where Id not in (Select Id from ?)",
                                      [objProp.Staff, this.lstLoggedByStaffs]
                                  )
                              ))
                        : null;
                    this.CFE(FilterTypes.TaggedStaffIds)
                        ? (this.lstTaggedStaffs = this.lstTaggedStaffs.concat(
                              alasql(
                                  "Select * from ? where Id not in (Select Id from ?)",
                                  [objProp.Staff, this.lstTaggedStaffs]
                              )
                          ))
                        : null;
                    this.CFE(FilterTypes.StaffsInvolved)
                        ? (this.lstInvolvedStaffs =
                              this.lstInvolvedStaffs.concat(
                                  alasql(
                                      "Select * from ? where Id not in (Select Id from ?)",
                                      [objProp.Staff, this.lstInvolvedStaffs]
                                  )
                              ))
                        : null;

                    this.CFE(FilterTypes.LoggedDate)
                        ? (this.lstloggedDate = [
                            {
                                Id: 1,
                                Name: this.translate.instant('LBL.YESTERDAY')
                            },
                            {
                                Id: 2,
                                Name: this.translate.instant('LBL.LBL_TODAY')
                            },
                            {
                                Id: 3,
                                Name: this.translate.instant('LBL.LAST_WEEK')
                            },
                            {
                                Id: 4,
                                Name: this.translate.instant('LBL.LAST_30_DAYS')
                            },
                            {
                                Id: 5,
                                Name: this.translate.instant('LBL.LBL_MONTH_TO_DATE')
                            },
                            {
                                Id: 6,
                                Name: this.translate.instant('LBL.LBL_YEAR_TO_DATE')
                            },
                        ])
                        : null;
                }
            }
        }

        //this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true });
        this.lstLastProps = _.cloneDeep(this.RequestModel.Properties);
        let ngbModalOptions: NgbModalOptions = {
            backdrop: "static",
            size: "lg",
            centered: true,
        };

        this.ModalRef = this.modalService.open(JobFilterInner, ngbModalOptions);
        this.innerFilter = this.ModalRef.componentInstance;

        let inner = this.innerFilter;

        inner.lstPriority = this.masterService.Cache_Global.Priority;
        inner.lstLocations = this.lstLocations;
        inner.lstCallDescriptions = this.lstCallDescriptions;
        inner.lstCallCategories = this.lstCallCategories;
        inner.lstStaff = this.lstStaff;
        inner.lstDepartments = this.lstDepartments;
        inner.lstSections = this.lstSections;
        inner.lstVIP = this.lstVIP;
        inner.lstGlitchCategories = this.lstGlitchCategories;
        inner.lstGlitchDescriptions = this.lstGlitchDescriptions;
        inner.lstGlitchStaffs = this.lstGlitchStaffs;
        inner.lstLoggedByStaffs = this.lstLoggedByStaffs;
        inner.lstTaggedStaffs = this.lstTaggedStaffs;
        inner.lstInvolvedStaffs = this.lstInvolvedStaffs;
        inner.lstloggedDate = this.lstloggedDate;
        inner.lastPax = this.lastPax;

        inner.ModalRef = this.ModalRef;
        inner.ApplyFilter.pipe(untilDestroyed(this)).subscribe((a) => {
            this.onFilterApply(a);
        });
        inner.EnabledFilters = this.EnabledFilters;
        inner.onOpen(Model);
    }

    onFilterApply(toEmit): void {
        this.ModalRef.close();
        this.ApplyFilter.emit(toEmit);
    }

    onClear(): void {
        this.innerFilter.onClear();
    }
}
